module.exports = __webpack_public_path__ + "img/add-icon.408a148e.svg";